var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox exchange-operate-page" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.detailLoading,
              expression: "detailLoading",
            },
          ],
          staticClass: "box-card",
          attrs: { shadow: "never" },
        },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-steps",
                {
                  staticClass: "operate-steps",
                  attrs: {
                    active: _vm.currentStep,
                    "align-center": "",
                    "finish-status": "success",
                  },
                },
                [
                  _c("el-step", { attrs: { title: "添加兑换积分活动" } }),
                  _vm._v(" "),
                  _c("el-step", { attrs: { title: "兑换积分规则" } }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "step-body" },
            [
              _c(
                "el-form",
                {
                  ref: "baseForm",
                  attrs: {
                    model: _vm.formData,
                    rules: _vm.rules,
                    "label-width": "92px",
                    size: "small",
                    disabled: _vm.isView,
                  },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentStep === 0,
                          expression: "currentStep === 0",
                        },
                      ],
                      staticClass: "step-panel step-one",
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "活动名称:",
                            prop: "activityName",
                            required: "",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "w-220",
                            attrs: {
                              maxlength: "50",
                              placeholder: "请输入活动名称",
                            },
                            model: {
                              value: _vm.formData.activityName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "activityName", $$v)
                              },
                              expression: "formData.activityName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "商品类型:",
                            prop: "goodsType",
                            required: "",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-220",
                              attrs: {
                                placeholder: "请选择",
                                disabled: _vm.mode === "edit",
                              },
                              on: { change: _vm.onGoodsTypeChange },
                              model: {
                                value: _vm.formData.goodsType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "goodsType", $$v)
                                },
                                expression: "formData.goodsType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "普通商品", value: "1" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "虚拟商品", value: "2" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "优惠券商品", value: "3" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动时间:", prop: "activityTime" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "activity-datetime-range",
                            attrs: {
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "default-time": _vm.activityTimeDefaultRange,
                              "start-placeholder": "开始时间",
                              "end-placeholder": "结束时间",
                              disabled: _vm.mode === "edit",
                              "picker-options": _vm.activityTimePickerOptions,
                            },
                            on: {
                              "visible-change": _vm.onActivityTimePickerVisible,
                              change: _vm.onActivityTimeChange,
                            },
                            model: {
                              value: _vm.formData.activityTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "activityTime", $$v)
                              },
                              expression: "formData.activityTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentStep === 1,
                          expression: "currentStep === 1",
                        },
                      ],
                      staticClass: "step-panel step-two",
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "perm-item",
                          attrs: { label: "卡片权限:", "label-width": "120px" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "perm-row" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "w-320",
                                  attrs: {
                                    multiple: "",
                                    filterable: "",
                                    remote: "",
                                    clearable: "",
                                    placeholder: "请选择",
                                    "remote-method":
                                      _vm.searchCardPermissionOptions,
                                    loading: _vm.cardPermLoading,
                                  },
                                  on: { change: _vm.onCardPermissionChange },
                                  model: {
                                    value: _vm.formData.cardPermissionIds,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "cardPermissionIds",
                                        $$v
                                      )
                                    },
                                    expression: "formData.cardPermissionIds",
                                  },
                                },
                                _vm._l(
                                  _vm.mergedCardPermissionOptions,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label:
                                          _vm.cardPermissionOptionLabel(item),
                                        value: item.id,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "perm-tip",
                                  attrs: { effect: "dark", placement: "top" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  控制小程序客户是否查看此活动商品，没有已选卡片的用户则商品在兑换积分板块不做展示\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "el-icon-question tip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "兑换方式:",
                            prop: "exchangeMode",
                            "label-width": "120px",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-220",
                              attrs: { disabled: _vm.isCouponGoodsType },
                              on: { change: _vm.onExchangeModeChange },
                              model: {
                                value: _vm.formData.exchangeMode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "exchangeMode", $$v)
                                },
                                expression: "formData.exchangeMode",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: "积分+现金兑换",
                                  value: "POINTS_CASH",
                                  disabled: _vm.isCouponGoodsType,
                                },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: {
                                  label: "积分+福卡/现金兑换",
                                  value: "POINTS_CARD_CASH",
                                  disabled: _vm.isCouponGoodsType,
                                },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "积分", value: "POINTS_ONLY" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.isCouponGoodsType
                            ? _c("p", { staticClass: "rule-help" }, [
                                _vm._v("优惠券商品仅支持纯积分兑换"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.formData.exchangeMode === "POINTS_CASH"
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "exchange-rule-form-item",
                              attrs: {
                                label: "兑换规则:",
                                "label-width": "120px",
                                required: "",
                              },
                            },
                            [
                              _c("div", [
                                _c("div", { staticClass: "rule-inline" }, [
                                  _c("div", { staticClass: "rule-field" }, [
                                    _c(
                                      "div",
                                      { staticClass: "rule-field-label" },
                                      [_vm._v("消耗积分")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "percent-row" },
                                      [
                                        _c("el-input-number", {
                                          staticClass: "percent-num",
                                          attrs: {
                                            min: 1,
                                            max: 100,
                                            precision: 0,
                                            step: 1,
                                            "step-strictly": "",
                                            controls: false,
                                            placeholder: "请输入",
                                          },
                                          on: {
                                            change:
                                              _vm.onSimpleRulePointsPercentChange,
                                          },
                                          model: {
                                            value:
                                              _vm.formData.simpleRule
                                                .pointsPercent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData.simpleRule,
                                                "pointsPercent",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.simpleRule.pointsPercent",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "suffix" }, [
                                          _vm._v("%"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "plus" }, [
                                    _vm._v("+"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "rule-field" }, [
                                    _c(
                                      "div",
                                      { staticClass: "rule-field-label" },
                                      [_vm._v("现金支付（元）")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "percent-row" },
                                      [
                                        _c("el-input-number", {
                                          staticClass: "percent-num",
                                          attrs: {
                                            min: 1,
                                            max: 100,
                                            precision: 0,
                                            step: 1,
                                            "step-strictly": "",
                                            controls: false,
                                            placeholder: "请输入",
                                          },
                                          on: {
                                            change:
                                              _vm.onSimpleRuleCashPercentChange,
                                          },
                                          model: {
                                            value:
                                              _vm.formData.simpleRule
                                                .cashPercent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData.simpleRule,
                                                "cashPercent",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.simpleRule.cashPercent",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "suffix" }, [
                                          _vm._v("%"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "rule-help" }, [
                                  _vm._v(
                                    "\n                如，商品默认售价为105.99元，消耗积分为20%，现金支付80%，则消耗积分为22，现金支付为84.79元。积分规则：存在小数，向上进取整；现金支付规则：存在小数，保留2位小数\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "integral-per-yuan-row" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "integral-per-yuan-text" },
                                      [_vm._v("1元 =")]
                                    ),
                                    _vm._v(" "),
                                    _c("el-input-number", {
                                      staticClass: "integral-per-yuan-input",
                                      attrs: {
                                        min: 1,
                                        precision: 0,
                                        step: 1,
                                        max: 1000,
                                        "step-strictly": "",
                                        controls: false,
                                        placeholder: "请输入",
                                      },
                                      model: {
                                        value:
                                          _vm.formData.simpleRule
                                            .integralPerYuan,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.simpleRule,
                                            "integralPerYuan",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.simpleRule.integralPerYuan",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "integral-per-yuan-text" },
                                      [_vm._v("积分")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "rule-help integral-per-yuan-help",
                                },
                                [
                                  _vm._v(
                                    "\n              如，1元=2积分，则移动端兑换商品总消耗积分需要用消耗积分值乘以2\n            "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formData.exchangeMode === "POINTS_ONLY"
                        ? _c(
                            "el-form-item",
                            {
                              staticClass:
                                "exchange-rule-form-item exchange-rule-form-item--points-only",
                              attrs: {
                                label: "兑换规则:",
                                "label-width": "120px",
                                required: "",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "exchange-rule-body exchange-rule-body--points-only",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "integral-per-yuan-row integral-per-yuan-row--lead",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "integral-per-yuan-text",
                                        },
                                        [_vm._v("1元 =")]
                                      ),
                                      _vm._v(" "),
                                      _c("el-input-number", {
                                        staticClass: "integral-per-yuan-input",
                                        attrs: {
                                          min: 1,
                                          precision: 0,
                                          step: 1,
                                          "step-strictly": "",
                                          controls: false,
                                          placeholder: "请输入",
                                        },
                                        model: {
                                          value: _vm.formData.integralPerYuan,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "integralPerYuan",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.integralPerYuan",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "integral-per-yuan-text",
                                        },
                                        [_vm._v("积分")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "rule-help integral-per-yuan-help",
                                },
                                [
                                  _vm._v(
                                    "\n              如，1元=2积分，则移动端兑换商品总消耗积分需要用商品售价乘以2\n            "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formData.exchangeMode === "POINTS_CARD_CASH"
                        ? _vm._l(
                            _vm.formData.fukaRuleRows,
                            function (row, index) {
                              return _c(
                                "div",
                                {
                                  key: "fuka-row-" + index,
                                  staticClass: "fuka-rule-group",
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "fuka-card-item",
                                      attrs: {
                                        label: "福卡:",
                                        "label-width": "120px",
                                        required: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "fuka-row-inner" },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticClass: "fuka-select-multi",
                                              attrs: {
                                                multiple: "",
                                                filterable: "",
                                                clearable: "",
                                                placeholder: "请选择",
                                              },
                                              on: {
                                                change: _vm.onFukaRowChange,
                                              },
                                              model: {
                                                value: row.fukaIds,
                                                callback: function ($$v) {
                                                  _vm.$set(row, "fukaIds", $$v)
                                                },
                                                expression: "row.fukaIds",
                                              },
                                            },
                                            _vm._l(
                                              _vm.availableIdsForFukaRow(index),
                                              function (id) {
                                                return _c("el-option", {
                                                  key: id,
                                                  attrs: {
                                                    label: _vm.cardLabel(id),
                                                    value: id,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                          _vm._v(" "),
                                          !_vm.isView
                                            ? _c("i", {
                                                directives: [
                                                  {
                                                    name: "has-permi",
                                                    rawName: "v-has-permi",
                                                    value:
                                                      _vm.exchangeOperatePerms,
                                                    expression:
                                                      "exchangeOperatePerms",
                                                  },
                                                ],
                                                staticClass:
                                                  "el-icon-circle-plus-outline add-icon",
                                                on: {
                                                  click: _vm.addFukaRuleRow,
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isView &&
                                          _vm.formData.fukaRuleRows.length > 1
                                            ? _c("i", {
                                                directives: [
                                                  {
                                                    name: "has-permi",
                                                    rawName: "v-has-permi",
                                                    value:
                                                      _vm.exchangeOperatePerms,
                                                    expression:
                                                      "exchangeOperatePerms",
                                                  },
                                                ],
                                                staticClass:
                                                  "el-icon-remove-outline remove-icon",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeFukaRuleRow(
                                                      index
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "exchange-rule-form-item",
                                      attrs: {
                                        label: "兑换规则:",
                                        "label-width": "120px",
                                        required: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "rule-inline" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "rule-field" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "rule-field-label",
                                                },
                                                [_vm._v("消耗积分")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "percent-row" },
                                                [
                                                  _c("el-input-number", {
                                                    staticClass: "percent-num",
                                                    attrs: {
                                                      min: 1,
                                                      max: 100,
                                                      precision: 0,
                                                      step: 1,
                                                      "step-strictly": "",
                                                      controls: false,
                                                      placeholder: "请输入",
                                                    },
                                                    on: {
                                                      change: function (v) {
                                                        return _vm.onFukaRowPointsPercentChange(
                                                          index,
                                                          v
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: row.pointsPercent,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          row,
                                                          "pointsPercent",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "row.pointsPercent",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    { staticClass: "suffix" },
                                                    [_vm._v("%")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "plus" }, [
                                            _vm._v("+"),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "rule-field" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "rule-field-label",
                                                },
                                                [_vm._v("现金/福豆支付")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "percent-row" },
                                                [
                                                  _c("el-input-number", {
                                                    staticClass: "percent-num",
                                                    attrs: {
                                                      min: 1,
                                                      max: 100,
                                                      precision: 0,
                                                      step: 1,
                                                      "step-strictly": "",
                                                      controls: false,
                                                      placeholder: "请输入",
                                                    },
                                                    on: {
                                                      change: function (v) {
                                                        return _vm.onFukaRowCashPercentChange(
                                                          index,
                                                          v
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: row.cashPercent,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          row,
                                                          "cashPercent",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "row.cashPercent",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    { staticClass: "suffix" },
                                                    [_vm._v("%")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      index == 0
                                        ? _c(
                                            "p",
                                            { staticClass: "rule-help" },
                                            [
                                              _vm._v(
                                                "\n                  如，商品默认售价为105.99元，消耗积分为20%，现金支付80%，则消耗积分为22，现金支付为84.79元。积分规则：存在小数，向上进取整；现金支付规则：存在小数，保留2位小数\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "integral-per-yuan-row",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "integral-per-yuan-text",
                                            },
                                            [_vm._v("1元 =")]
                                          ),
                                          _vm._v(" "),
                                          _c("el-input-number", {
                                            staticClass:
                                              "integral-per-yuan-input",
                                            attrs: {
                                              min: 0,
                                              precision: 0,
                                              step: 1,
                                              "step-strictly": "",
                                              controls: false,
                                              placeholder: "请输入",
                                            },
                                            model: {
                                              value: row.integralPerYuan,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  row,
                                                  "integralPerYuan",
                                                  $$v
                                                )
                                              },
                                              expression: "row.integralPerYuan",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "integral-per-yuan-text",
                                            },
                                            [_vm._v("积分")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      index == 0
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "rule-help integral-per-yuan-help",
                                            },
                                            [
                                              _vm._v(
                                                "\n                  如，1元=2积分，则移动端兑换商品总消耗积分需要用消耗积分值乘以2\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "customer-item",
                          attrs: {
                            label: "适用分销客户:",
                            "label-width": "120px",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: {
                                disabled: _vm.isView || _vm.mode === "edit",
                                size: "small",
                              },
                              on: { change: _vm.onApplyCustomerTypeChange },
                              model: {
                                value: _vm.formData.applyCustomerType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "applyCustomerType",
                                    $$v
                                  )
                                },
                                expression: "formData.applyCustomerType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("全部"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("部分"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.formData.applyCustomerType === 1,
                              expression: "formData.applyCustomerType === 1",
                            },
                          ],
                          staticClass: "customer-item customer-select-item",
                          attrs: {
                            label: "",
                            "label-width": "120px",
                            required: _vm.formData.applyCustomerType === 1,
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-220",
                              attrs: {
                                multiple: "",
                                filterable: "",
                                remote: "",
                                clearable: "",
                                disabled: _vm.mode === "edit",
                                "remote-method": _vm.searchCustomerOptions,
                                loading: _vm.customerLoading,
                                placeholder: "请选择适用分销客户",
                              },
                              model: {
                                value: _vm.formData.customerScope,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "customerScope", $$v)
                                },
                                expression: "formData.customerScope",
                              },
                            },
                            _vm._l(_vm.customerOptions, function (item) {
                              return _c("el-option", {
                                key: item.customerId,
                                attrs: {
                                  label: item.appName,
                                  value: item.customerId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "footer-actions" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary", plain: "" },
                  on: { click: _vm.handleCancel },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _vm.currentStep > 0
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.prevStep },
                    },
                    [_vm._v("上一步")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentStep < 1
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.nextStep },
                    },
                    [_vm._v("下一步")]
                  )
                : !_vm.isView
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: _vm.exchangeOperatePerms,
                          expression: "exchangeOperatePerms",
                        },
                      ],
                      attrs: {
                        size: "small",
                        type: "primary",
                        loading: _vm.submitLoading,
                      },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v("\n        提交\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }